import React from 'react';
import Space from 'v3/components/Space';
import Button from 'v3/components/Button';
import Text from 'v3/components/Text';

export default function Editable({
  isEditing,
  setEditing,
  onSave,
  isLoading,
  add,
  openModal,
  hasPermissionToEditCostCenter,
  costCenter,
  setData,
  selectOptions,
}) {
  function handleCancel() {
    setEditing(false);
    setData({
      ...costCenter,
      limitSchedule: costCenter?.limitSchedule ? selectOptions[1] : selectOptions[0],
      showLoadingOrder: costCenter?.showLoadingOrder ? selectOptions[1] : selectOptions[0],
      travelWithoutExternalId: costCenter?.travelWithoutExternalId ? selectOptions[1] : selectOptions[0],
      travelSplitDelivery: costCenter?.travelSplitDelivery ? selectOptions[1] : selectOptions[0],
    });
  }

  if (isEditing) {
    return (
      <Space x="5px">
        <Button variant="secondary" onClick={handleCancel} className="py-2">
          <Text type="regular" color="dark" weight="500">
            Cancelar
          </Text>
        </Button>
        <Button
          variant="primary"
          onClick={onSave}
          loading={isLoading}
          className="py-2"
        >
          <Text type="regular" color="white" weight="500">
            Salvar
          </Text>
        </Button>
      </Space>
    );
  }

  return (
    <>
      {add ? (
        <Button variant="primary" onClick={() => openModal()} className="py-2">
          <Text color="white" weight="500" type="regular">
            Adicionar
          </Text>
        </Button>
      ) : (
        <Button
          variant="secondary"
          onClick={() => setEditing(true)}
          className="py-2"
          disabled={!hasPermissionToEditCostCenter}
        >
          <Text color="dark" weight="500" type="regular">
            Editar
          </Text>
        </Button>
      )}
    </>
  );
}
